<template>
  <div>
    <v-card elevation="1">
      <v-card-text>
        <h4>Modificadores para {{ productoData.Nombre }}</h4>
        <v-divider />
        <v-row class="mt-2">
          <v-col md="4">
            <v-autocomplete label="Modificadores" v-model="modificador" @change="onChangeModificador()"
              :items="modificadoresByDepartamento" item-text="Nombre" item-value="Id" dense outlined>
            </v-autocomplete>
          </v-col>
          <v-col md="4">
            <v-autocomplete v-if="useOrigen" label="Centro de consumo" v-model="origen" :items="origenes"
              item-text="Nombre" item-value="id" dense outlined>
            </v-autocomplete>
          </v-col>
          <v-col md="4">
            <v-btn :disabled="!modificador" block color="blue" outlined dark @click="addModificador()"> Agregar +
            </v-btn>
          </v-col>
        </v-row>
        <v-divider />
        <v-list v-if="productoData.Modificadores">
          <template v-for="(modi, index) in productoData.Modificadores">
            <v-list-item :key="index">
              <v-row>
                <v-col md="8">
                  {{ $pgsHelper.getById(getModificadores, "Id", modi.id).Nombre }}
                  <p v-if="modi.orn">Origen: {{ $pgsHelper.getById(origenes, "id", modi.orn).Nombre }}</p>
                </v-col>
                <v-col md="4">
                  <v-btn @click="deleteModificador(index)" small dark color="red">Eliminar</v-btn>
                </v-col>
              </v-row>
            </v-list-item>
            <v-divider :key="index + 'i'"></v-divider>
          </template>
        </v-list>
        <v-alert v-if="!productoData.Modificadores" border="bottom" colored-border type="info" elevation="2">
          El producto no cuenta con modificadores.
        </v-alert>
        <div class="text-right">
          <v-btn @click="$emit('toggle', false)">Cancelar</v-btn>
          <v-btn @click="checkForm()" style="margin-left: 6px" color="success">Guardar</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Producto from "../../../clases/Producto.js";
import { mapGetters } from "vuex";
export default {
  name: "ProductosModificadores",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      productoData: Producto.getPropertyModel(),
      modificador: "",
      origen: null,
      useOrigen: false
    };
  },
  methods: {
    checkForm: function (e) {
      let doAction = "CREATE";
      if (this.edit) {
        doAction = "EDIT";
      }
      this.$emit("successData", this.productoData, doAction);
    },
    onChangeModificador() {
      let useOrigen = false
      let modificador = this.$pgsHelper.getById(this.getModificadores, "Id", this.modificador);
      if (modificador) {
        modificador.Opciones.forEach(opciones => {
          if (opciones.ref) {
            if (opciones.ref.or) {
              useOrigen = true;
            }
          }
        })
      }
      this.useOrigen = useOrigen
      this.origen = (useOrigen) ? "" : null
    },
    addModificador() {
      this.productoData.addModificador({
        id: this.modificador,
        orn: this.origen
      });
    },
    deleteModificador(index) {
      this.productoData.deleteModificador(index)
    },
  },
  computed: {
    ...mapGetters("dataLists", ["getModificadores"]),
    modificadoresByDepartamento() {
      let modificador = [];
      this.getModificadores.forEach((modi) => {
        if (this.productoData.Departamentos) {
          if (this.productoData.Departamentos.includes(modi.Departamento) && !modi.Dlat) {
            modificador.push(modi);
          }
        }
      })
      return modificador
    },
    origenes() {
      let ori = this.$store.getters.getCentrosConsumo;
      return ori;
    },
  },
  watch: {},
  beforeMount: function () { },
  mounted() {
    this.loader = false;
    if (this.edit) {
      this.productoData = new Producto(this.dataEdit);
    } else {
      this.productoData = new Producto();
    }
  },
};
</script>